import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { FaSave, FaExclamationCircle, FaPlus, FaTrash } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';

import { API } from 'aws-amplify';
import { Formik } from "formik";
import * as yup from "yup";

import { useToasts } from 'react-toast-notifications';

import * as localdb from '../../../localdb';
import './TaskAdd.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';

const TaskAdd = (props) => {
    const { t, tCatalog, language } = useI18n();
    const [assets, setAssets] = useState([]);
    const [assetFiltered, setAssetsFiltered] = useState([]);
    const [district, setDistrict] = useState();
    const [isTaskEdit, setTaskEdit] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [inventoryItems, setInventoryItems] = useState([]);
    const [selectedMaterialId, setSelectedMaterialId] = useState('');
    const [selectedMaterialQty, setSelectedMaterialQty] = useState(1);
    const [materialSearch, setMaterialSearch] = useState('');
    const { addToast } = useToasts();
    const [task, setTasks] = useState({fault_description: '',      
                                        assetId: props.match.params.assetId,
                                        category: '',
                                        type_fault: '',
                                        sla_attend: '',
                                        sla_repair: '',
                                        contractor: '', 
                                        contractor_ref: '',
                                        date_created: new Date().toISOString(),                                                                             
                                        urgent_fault: '',
                                        chargeable: 'Fixed',
                                        task_status: 'Created',
                                        task_active: true,
                                        materials: '',
                                        materials_items: [],
                                        callout_nr: '',
                                        callout_rate: '',
                                        callout_subtotal: '',
                                        onsite_nr: '',
                                        onsite_rate: '',
                                        onsite_subtotal: '',
                                        total_cost: '',
                                        task_ref: '',
                                        job_number: '',
                                        invoice_date: '',
                                        invoice_number: '',
                                    });
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedClassification, setSelectedClassification] = useState("");
    const [subcategory, setSubCategory] = useState([]);
    const [slaAttendList, setSlaAttendList] = useState([]);
    const [slaRepairList, setSlaRepairList] = useState([]);
    const [hpsite, setHPsite] = useState('-');
    const [contractorList, setContractorList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	const [riAlert, setRIAlert] = useState(false);
    
    const params = { 
        headers: {
            'x-api-key': (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_KEY) || '',        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }

    // Load contractors
	useEffect(()=>{
        const fetchInventory = async () => {
            try {
                const res = await API.get('inventory', '/', params);
                const sorted = (res || []).sort((a, b) => ((a.description || '') > (b.description || '') ? 1 : -1));
                setInventoryItems(sorted);
            } catch (err) {
                addToast(t('toast.errorLoadingInventory'), { appearance: 'error' });
            }
        };
        fetchInventory();
    }, []);

    useEffect(()=>{
		const fetchContractors = async () => {
			
			const contractors = await API.get('settings','/CONTRACTORS', params)
			contractors.values.sort((a, b) => (a > b) ? 1 : -1)

			let list = []
			for (let i = 0; i < contractors.values.length; i++) {
				list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)
			}

			setContractorList(list);

		}
		fetchContractors();	 
    }, []);

    // Load district
	useEffect(()=>{
		const fetchDistrict = async () => {
			
			const districts = await API.get('settings','/DISTRICTS', params)
			const unique = [...new Set((districts.values || []).filter(Boolean))]
				.sort((a, b) => (a > b) ? 1 : -1);

			const list = unique.map((name) => (
				<option key={name} value={name}>{name}</option>
			));

			setDistrictList(list);
		}
		fetchDistrict();	 
	}, []);

      // Load Assets
      useEffect(() => {
        API.get('assets','/', params)
        .then(res => {
            
            //sort array 
			res.sort((a, b) => (a.site_ref > b.site_ref) ? 1 : -1)
            setAssets(res);
            setAssetsFiltered(res);
        }) 
        .catch((err) => {
            addToast(t('toast.errorLoadingAssets'), { appearance: 'error' });
        }); 

    },[]);

    // Load task 
    useEffect(()=>{
        // Edit task
        if (props.match.params.id){
            setTaskEdit(true);
            API.get('task_active','/' + props.match.params.id, params)
            .then(task => { 
                if (task.contractor_ref === undefined) task.contractor_ref=''
                if (task.category === undefined) task.category=''
                if (task.type_fault === undefined) task.type_fault=''
                if (task.materials === undefined) task.materials=''
                if (task.materials_items === undefined) task.materials_items=[]
                if (task.callout_nr === undefined) task.callout_nr=''
                if (task.callout_rate === undefined) task.callout_rate=''
                if (task.callout_subtotal === undefined) task.callout_subtotal=''
                if (task.onsite_nr === undefined) task.onsite_nr=''
                if (task.onsite_rate === undefined) task.onsite_rate=''
                if (task.onsite_subtotal === undefined) task.onsite_subtotal=''
                if (task.total_cost === undefined) task.total_cost=''
                if (task.chargeable === 'true') task.chargeable = 'Chargeable'
                if (task.chargeable === 'false') task.chargeable = 'Fixed'
                if (task.chargeable === undefined || task.chargeable === '') task.chargeable='Fixed'
                if (task.job_number === undefined) task.job_number=''
                if (task.invoice_date === undefined) task.invoice_date=''
                if (task.invoice_number === undefined) task.invoice_number=''
                if (task.materials_items && task.materials_items.length > 0) {
                    const matTotal = task.materials_items.reduce((sum, item) => sum + Number(item.total || (Number(item.quantity || 0) * Number(item.price || 0))), 0);
                    task.materials = +(parseFloat(matTotal)).toFixed(2);
                }

                setTasks(task);
                // Process RI data for alert indicators
                if (task.ri) {
                    processRIData(task);
                }
                handleSubCateg(task.category);
                setTaskEdit(false);  

            });
        }else if (props.user && props.user.username){
            setTaskEdit(true);           
            setTasks({...task, user_created: props.user.username});    
            
            // task from asset detail
            // if (props.match.params.assetId){    
            //     // console.log(props.match.params.assetId)          
            //     setTasks({...task, assetId: props.match.params.assetId, user_created: props.user.username})               
            //    }else{
            //     setTasks({...task, user_created: props.user.username});    
            //  }

            setTaskEdit(false);
        }


    }, [props])


    useEffect(() => {
        if (task){
            // console.log(district)
            // find district
            const task_asset = assets.find(i => i.assetId === task.assetId);
            if (task_asset) {
                setDistrict(task_asset.district);              
                setHPsite(task_asset.hp_site);
                handleFilterDistrict(district);
            }
        }
    },[task, assets]);


    // subcategories
    const handleSubCateg = (selCategory) => {
        
        setSelectedCategory(selCategory);
        const cat = localdb.CATEGORY;
        let subcat = "";
        let sla_attend = "";
        let sla_repair = "";

        for (let i = 0; i < cat.length; i++) {
            if (cat[i].key === selCategory){
                subcat = cat[i].subcategory.map((item, j) => (
                <option key={"subcategory"+j} value={item} >{tCatalog(item)}</option>)
                )  
                sla_attend = cat[i].sla_attend && cat[i].sla_attend.map((item, j) => (
                <option key={"sla_attend"+j} value={item} >{item + " " + tCatalog(cat[i].sla_attend_in)}</option>)
                )  
                sla_repair = cat[i].sla_repair && cat[i].sla_repair.map((item, j) => (
                <option key={"sla_repair"+j} value={item} >{item + " " + tCatalog(cat[i].sla_repair_in)}</option>)
                ) 
            }
        }
        // console.log(subcat)
        if (subcat){
            setSubCategory(subcat);
            setSlaAttendList(sla_attend);
            setSlaRepairList(sla_repair);
        }
        if (selectedClassification){
            handleClassification(selectedClassification, selCategory);
        }
    }

    // subcategories
    const handleClassification = (selClassification, selCategory) => {
        setSelectedClassification(selClassification);
        if ((typeof process !== 'undefined' && process.env && process.env.REACT_APP_GLOB_APP_ENV === 'sdcc') && selCategory == 'Reactive' && (selClassification == 'Urgent' || selClassification == 'Non-Urgent')) {
            const cat = localdb.CATEGORY;
            let sla_attend = "";
            let sla_repair = "";
            let classificationString = "";
            if (selClassification === "Urgent") classificationString = "urgent";
            if (selClassification === "Non-Urgent") classificationString = "non_urgent";

            for (let i = 0; i < cat.length; i++) {
                if (cat[i].key === selCategory){
                    sla_attend = cat[i]["sla_attend_sdcc_" + classificationString] && cat[i]["sla_attend_sdcc_" + classificationString].map((item, j) => (
                    <option key={"sla_attend"+j} value={item} >{item + " " + tCatalog(cat[i].sla_attend_in)}</option>)
                    )
                    sla_repair = cat[i]["sla_repair_sdcc_" + classificationString] && cat[i]["sla_repair_sdcc_" + classificationString].map((item, j) => (
                    <option key={"sla_repair"+j} value={item} >{item + " " + tCatalog(cat[i].sla_repair_in)}</option>)
                    )
                }
            }
            setSlaAttendList(sla_attend);
            setSlaRepairList(sla_repair);
        }
    }

    useEffect(() => {
        if (selectedCategory) handleSubCateg(selectedCategory);
    }, [language]);

    // let assetFiltered = [...assets];
    // filter district
    const handleFilterDistrict = (selDistrict) => {
        let filter =[]
        // console.log(selDistrict.toLowerCase())
        if (selDistrict)
            filter = assets.filter(item => item.district && item.district.toLowerCase().includes(selDistrict.toLowerCase()))
        else
            filter = assets
            // filter = assets.filter(item => item.district === selDistrict)
        setAssetsFiltered(filter);
    }

    // handle asset HP site
    const handleAssetChange = (selAsset) => {
        const temp_assets = [...assets];
        const asset = temp_assets.find(item => item.assetId === selAsset)
        if (asset) setHPsite(asset.hp_site); else setHPsite('-');
        if (district)  { 
            handleFilterDistrict(district);  
        } else{  
            if (asset){
            setDistrict(asset.district)
            handleFilterDistrict(asset.district);
            }
        } 

    }
  
    // handle SLA by category of work, sub-category, hp site & classification
    function handleSLA(cat, subcat, urg, asset){
        let sla = [];

        switch (cat) {
            case 'Reactive': 
                let hps =""
                const hp = assets.find(item => item.assetId === asset)
                if (hp) hps = hp.hp_site; 

                // default sla for reactive
                sla = ["0","0","Chargeable",urg];

                if (urg === "Urgent" && hps === true) sla = ["2","5","Chargeable", urg]
                if (urg === "Urgent" && hps === false) sla = ["4","7","Chargeable", urg]
                if (urg === "Non-Urgent") sla = ["18","24","Chargeable", urg]

                break;
            case 'PPM': 
                // default sla for reactive
                sla = ["0","0","Fixed","Scheduled"];

                if (subcat === "Periodic Inspection" 
                    || subcat === "Annual Inspection (Signals)"
                    || subcat === "Annual Inspection (Structures)"
                    || subcat === "Annual Inspection (Signs)") sla = ["0","14","Fixed","Scheduled"]
             
                if (subcat === "Periodic Inspection Report" 
                    || subcat === "Annual Inspection Report") sla = ["0","7","Fixed","Scheduled"]

                if (subcat === "Routine Maintenance" 
                    || subcat === "Non LED Lamp replacement") sla = ["0","0","Fixed","Scheduled"]

                break;
            case 'Signs': 
                if (subcat === "Sign fault") 
                    sla = ["0","0","Chargeable","Non-Urgent"] 
                else 
                    sla = ["0","0","Chargeable","Scheduled"]

                break;
            case 'Switch off / on': case 'Upgrade': case 'Other': 
                sla = ["0","0","Chargeable","Scheduled"];
                break;
            default: 
                sla = [];
        }
        
		return sla
	}

    // Process RI data for alert indicators
    const processRIData = (taskData) => {
        if (!taskData.ri) return;
        
        const ri = taskData.ri;
        let hasAlert = false;
        
        // Set default CSS classes
        const cssClasses = {
            cssLamps_fault: "text-secondary mr-3",
            cssSignal_head: "text-secondary mr-3",
            cssCaps_Bungs: "text-secondary mr-3",
            cssPush_buttons: "text-secondary mr-3",
            cssControllers: "text-secondary mr-3",
            cssAll_detection: "text-secondary mr-3",
            cssLogBook: "text-secondary mr-3",
            cssSite_issues: "text-secondary mr-3",
            cssDoor: "text-secondary mr-3"
        };
        
        // Check each question
        if (ri.q1_lamps) {
            cssClasses.cssLamps_fault = ri.q1_lamps.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q1_lamps.ok) hasAlert = true;
        }
        if (ri.q2_signal_heads) {
            cssClasses.cssSignal_head = ri.q2_signal_heads.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q2_signal_heads.ok) hasAlert = true;
        }
        if (ri.q3_caps_bungs) {
            cssClasses.cssCaps_Bungs = ri.q3_caps_bungs.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q3_caps_bungs.ok) hasAlert = true;
        }
        if (ri.q4_push_buttons) {
            cssClasses.cssPush_buttons = ri.q4_push_buttons.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q4_push_buttons.ok) hasAlert = true;
        }
        if (ri.q5_controller) {
            cssClasses.cssControllers = ri.q5_controller.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q5_controller.ok) hasAlert = true;
        }
        if (ri.q6_detection) {
            cssClasses.cssAll_detection = ri.q6_detection.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q6_detection.ok) hasAlert = true;
        }
        if (ri.q7_log_book) {
            cssClasses.cssLogBook = ri.q7_log_book.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q7_log_book.ok) hasAlert = true;
        }
        if (ri.q8_site_issues) {
            cssClasses.cssSite_issues = ri.q8_site_issues.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q8_site_issues.ok) hasAlert = true;
        }
        if (ri.q9_door) {
            cssClasses.cssDoor = ri.q9_door.ok ? "text-success mr-3" : "text-danger mr-3";
            if (!ri.q9_door.ok) hasAlert = true;
        }
        
        setRIAlert(hasAlert);
        // Store CSS classes in task object
        setTasks(prevTask => ({ ...prevTask, ...cssClasses }));
    }

    const calculateTotalCost = (materials, calloutSubtotal, onsiteSubtotal) => {
        const m = Number(materials || 0);
        const c = Number(calloutSubtotal || 0);
        const o = Number(onsiteSubtotal || 0);
        return +(parseFloat(m + c + o)).toFixed(2);
    };

    // Form Submit
    const handleSubmit = (data) => {

        //Edit task
        if (task){
            data.taskId = task.taskId
        }
        
        if (!data.user_created){
            data.user_created = task.user_created;
        }
    
        // Preserve RI data if it exists
        const riData = data.ri;
        const isAdmin = props.user && props.user.administrator === 'true';
        
        //Clean up data before Post (but preserve objects like RI)
        data = Object.entries(data).reduce((a,[k,v]) => {
            // Preserve objects like 'ri' even if they might be considered empty
            if (k === 'ri' && v && typeof v === 'object') {
                return {...a, [k]: v};
            }
            if (v === null || v === '') {
                return a;
            }
            return {...a, [k]: v};
        }, {})
        
        // Ensure RI data is included if it was present
        // For non-admins, preserve original task RI data (no changes allowed)
        if (riData && typeof riData === 'object') {
            if (isAdmin) {
                data.ri = riData; // Admins can modify
            } else if (task.ri) {
                data.ri = task.ri; // Non-admins keep original
            }
        } else if (task.ri) {
            data.ri = task.ri; // Ensure original RI is preserved if form doesn't have it
        }

        return API.post('task_active', '/', {      
            body: data,
            headers: {
                'x-api-key': (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_KEY) || '',        
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(response => {
            addToast(t('toast.taskSaved'), { appearance: 'success' });
            props.history.push('/task_det/'+ response );           
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorSavingTask'), { appearance: 'error' });
            setBtnDisabled(false);
            throw error; // Re-throw to be caught by onSubmit handler
        });  
    };
  
      
    const categoryList = localdb.CATEGORY.map((item, i) => (
        <option key={"category"+i} value={item.key}>{tCatalog(item.description)}</option>
    ));

    const schema = yup.object().shape({
        fault_description: yup.string()
            .required(t('common.required')),
        assetId: yup.string()
            .required(t('common.required')),
        category: yup.string()
            .required(t('common.required')),
        type_fault: yup.string()
            .required(t('common.required')),
        sla_attend: yup.string(),
        sla_repair: yup.string(),
        contractor: yup.string(), 
        contractor_ref: yup.string(),
        materials: yup.number(),
        callout_nr: yup.number(),
        callout_rate: yup.number(),
        callout_subtotal: yup.number(),
        onsite_nr: yup.number(),
        onsite_rate: yup.number(),
        onsite_subtotal: yup.number(),
        total_cost: yup.number(),
        task_ref: yup.number(),
        invoice_date: yup.string(),
        invoice_number: yup.string(),
        });

    
    return(
        // enableReinitialize      
        !isTaskEdit ? (
        <React.Fragment> 
        <Formik                                   
            initialValues={task}
            validationSchema={schema}
            onSubmit={ async (values, { setSubmitting }) => {
                setBtnDisabled(true);
                setSubmitting(true);
                try {
                    await handleSubmit(values);
                } catch (error) {
                    setBtnDisabled(false);
                } finally {
                    setSubmitting(false);
                }
            }}

            >
            {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => {
                
                // Map fields to tabs
                const tabFields = {
                    details: ['fault_description', 'assetId', 'category', 'type_fault'],
                    costs: [],
                    inspection: []
                };
                
                // Check which tabs have errors
                const getTabHasError = (tabKey) => {
                    const fields = tabFields[tabKey] || [];
                    return fields.some(field => errors[field] && touched[field]);
                };
                
                // Render tab title with error indicator
                const renderTabTitle = (tabKey, defaultTitle) => {
                    const hasError = getTabHasError(tabKey);
                    if (hasError) {
                        return <span className="text-danger"><FaExclamationCircle className="mr-1" />{defaultTitle}</span>;
                    }
                    return defaultTitle;
                };

            return (
            <div className="TaskAdd">
            <div className="col-md-12">
            <form onSubmit={handleSubmit}>

            <PageHeader
                title={
                    props.match.params.id ? (
                        <>
                            <h1 className="header-title">{t('pages.taskAdd.editTitle')}</h1>
                            {task.task_ref && <span className="task-ref-mark">#{task.task_ref}</span>}
                        </>
                    ) : t('pages.taskAdd.newTitle')
                }
                pageTitle={props.match.params.id ? `${t('pages.taskAdd.editTitle')} ${task.task_ref || ''}`.trim() : t('pages.taskAdd.newTitle')}
                breadcrumbs={[
                    { label: t('nav.tasks'), path: '/tasks' },
                    { label: props.match.params.id ? (task.task_ref || t('common.edit')) : t('pages.taskAdd.newTitle') },
                ]}
                backTo={props.match.params.id ? `/task_det/${props.match.params.id}` : '/tasks'}
                backLabel={props.match.params.id ? t('pages.taskAdd.backToDetails') : t('nav.tasks')}
                subtitle={props.match.params.id ? t('pages.taskAdd.editSubtitle') : t('pages.taskAdd.newSubtitle')}
                actions={
                    <Button variant="primary" size="sm" className="task-action-btn" type="submit" disabled={btnDisabled || isSubmitting}>
                        {t('taskForm.save')} <FaSave />
                    </Button>
                }
            />
            
            <div className="row div-content">
            <div className="col-12">
            <Tabs defaultActiveKey="details" transition={false} id="tab_task_det">
            <Tab eventKey="details" title={renderTabTitle('details', t('actions.details'))}>
                <TabContent>
                    <section className="form-section">
                    <h4 className="form-section-title">{t('fields.workRequired')}</h4>
                    <Form.Group controlId="fault_description" className={touched.fault_description && errors.fault_description ? "has-error" : null}>
                        <Form.Control
                            as="textarea"
                            rows="4"
                            className="work-required"
                            value={values.fault_description}
                            onChange={handleChange}
                        />
                        {touched.fault_description && errors.fault_description ? <div className="error-message">{errors.fault_description}</div> : null}
                    </Form.Group>
                    </section>

                    <section className="form-section">
                    <h4 className="form-section-title">{t('fields.siteAndPriority')}</h4>
                    <div className="form-grid">
                            <Form.Group controlId="district" className={touched.district && errors.district ? "has-error" : null}>
                                <Form.Label>{t('common.district')}</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={district}
                                    onChange={e => {
                                    setDistrict(e.target.value);
                                    handleFilterDistrict(e.target.value)}}>
                                        <option value="">{t('common.select')}</option>
                                        {districtList}
                                </Form.Control>
                                {touched.district && errors.district ? <div className="error-message">{errors.district}</div> : null}
                            </Form.Group>
                        <Form.Group controlId="assetId" className={touched.assetId && errors.assetId ? "has-error" : null}>
                                    <Form.Label>{t('fields.siteRef')}</Form.Label>
                            <Form.Control
                                as="select"
                                value={values.assetId}
                                onChange={e => {
                                    handleChange(e);
                                    handleAssetChange(e.target.value);
                                    const sla = handleSLA(values.category, values.type_fault, values.urgent_fault, e.target.value);
                                    setFieldValue('sla_attend', sla[0], false);
                                    setFieldValue('sla_repair', sla[1], false);
                                    setFieldValue('chargeable', sla[2], false);
                                    setFieldValue('urgent_fault', sla[3], false);
                                }}>
                                    <option value="">{t('common.select')}</option>
                                    { assetFiltered.map(item => (
                                        <option key={item.assetId} value={item.assetId}>
                                            {item.site_ref} - {item.site_address}
                                        </option>
                                        ))
                                    }
                            </Form.Control>
                            {touched.assetId && errors.assetId ? <div className="error-message">{errors.assetId}</div> : null}
                        </Form.Group>
                        <Form.Group controlId="hp_site">
                            <Form.Label>{t('fields.prioritySite')}</Form.Label>
                            <ButtonGroup className="priority-toggle" aria-label="Priority Site">
                                <Button type="button" variant="outline-secondary" className={hpsite === true ? 'is-selected' : ''}>{t('assets.high')}</Button>
                                <Button type="button" variant="outline-secondary" className={hpsite === false ? 'is-selected' : ''}>{t('assets.low')}</Button>
                            </ButtonGroup>
                        </Form.Group>
                    </div>
                    </section>

                    <section className="form-section">
                    <h4 className="form-section-title">{t('fields.workClassificationSla')}</h4>
                    <div className="form-grid">
                    <Form.Group controlId="category" className={touched.category && errors.category ? "has-error" : null}>
                        <Form.Label>{t('fields.categoryOfWork')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.category}
                            onChange={e => {
                                handleChange(e);
                                handleSubCateg(e.target.value);

                                const sla = handleSLA(e.target.value, values.type_fault, values.urgent_fault, values.assetId);
                                setFieldValue('sla_attend', sla[0], false);
                                setFieldValue('sla_repair', sla[1], false);
                                setFieldValue('chargeable', sla[2], false);
                                setFieldValue('urgent_fault', sla[3], false);

                                }}>
                                <option value="">{t('common.select')}</option>
                                {categoryList}
                        </Form.Control>
                        {touched.category && errors.category ? <div className="error-message">{errors.category}</div> : null}
                    </Form.Group>
                    <Form.Group controlId="type_fault" className={touched.type_fault && errors.type_fault ? "has-error" : null}>
                        <Form.Label>{t('fields.subCategory')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.type_fault}
                            onChange={e => {
                                handleChange(e);
                                const sla = handleSLA(values.category, e.target.value, values.urgent_fault, values.assetId);
                                setFieldValue('sla_attend', sla[0], false);
                                setFieldValue('sla_repair', sla[1], false);
                                setFieldValue('chargeable', sla[2], false);
                                setFieldValue('urgent_fault', sla[3], false);

                            }}>
                                <option value="">{t('common.select')}</option>
                                {subcategory}
                        </Form.Control>
                        {touched.type_fault && errors.type_fault ? <div className="error-message">{errors.type_fault}</div> : null}
                    </Form.Group>
                    <Form.Group controlId="urgent_fault" >
                        <Form.Label>{t('common.classification')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.urgent_fault}
                            onChange={e => {
                                handleChange(e);
                                handleClassification(e.target.value, selectedCategory);

                                const sla = handleSLA(values.category, values.type_fault, e.target.value, values.assetId);
                                setFieldValue('sla_attend', sla[0], false);
                                setFieldValue('sla_repair', sla[1], false);
                                setFieldValue('chargeable', sla[2], false);
                                setFieldValue('urgent_fault', sla[3], false);

                            }}>
                                <option value="">{t('common.select')}</option>
                                <option value="Urgent">{tCatalog('Urgent')}</option>
                                <option value="Non-Urgent">{tCatalog('Non-Urgent')}</option>
                                <option value="Scheduled">{tCatalog('Scheduled')}</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="sla_attend" className={touched.sla_attend && errors.sla_attend ? "has-error" : null}>
                        <Form.Label>{t('fields.slaToAttend')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.sla_attend}
                            onChange={handleChange}>
                                <option value="">{t('common.select')}</option>
                                {slaAttendList}
                                <option value="0">N/A</option>
                        </Form.Control>
                        {touched.sla_attend && errors.sla_attend ? <div className="error-message">{errors.sla_attend}</div> : null}
                    </Form.Group>
                    <Form.Group controlId="sla_repair" className={touched.sla_repair && errors.sla_repair ? "has-error" : null}>
                        <Form.Label>{t('fields.slaToComplete')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.sla_repair}
                            onChange={handleChange}>
                                <option value="">{t('common.select')}</option>
                                {slaRepairList}
                                <option value="0">N/A</option>
                        </Form.Control>
                        {touched.sla_repair && errors.sla_repair ? <div className="error-message">{errors.sla_repair}</div> : null}
                    </Form.Group>
                    <Form.Group controlId="chargeable" >
                        <Form.Label>{t('fields.chargeable')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.chargeable}
                            onChange={handleChange}>
                                <option value="Fixed">{tCatalog('Fixed')}</option>
                                <option value="Quoted">{tCatalog('Quoted')}</option>
                                <option value="Chargeable">{tCatalog('Chargeable')}</option>
                        </Form.Control>
                    </Form.Group>
                    </div>
                    </section>

                    <section className="form-section">
                    <h4 className="form-section-title">{t('fields.contractorDetails')}</h4>
                    <div className="form-grid">
                    <Form.Group controlId="contractor" className={touched.contractor && errors.contractor ? "has-error" : null}>
                        <Form.Label>{t('common.contractor')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.contractor}
                            onChange={handleChange}>
                                <option value="">{t('common.select')}</option>
                                {contractorList}
                        </Form.Control>
                        {touched.contractor && errors.contractor ? <div className="error-message">{errors.contractor}</div> : null}
                    </Form.Group>
                        <Form.Group controlId="contractor_ref" >
                            <Form.Label>{t('fields.contractorRef')}</Form.Label>
                            <Form.Control
                                as="input"
                                value={values.contractor_ref}
                                onChange={handleChange} type="text" />
                        </Form.Group>
                        <Form.Group controlId="job_number" >
                            <Form.Label>{t('fields.jobNumber')}</Form.Label>
                            <Form.Control
                                as="input"
                                value={values.job_number || ''}
                                onChange={handleChange}
                                type="text"
                            />
                        </Form.Group>
                    </div>
                    </section>
                    {props.match.params.id && (
                        <section className="form-section">
                            <h4 className="form-section-title">{t('taskView.invoice')}</h4>
                            <div className="form-grid">
                                <Form.Group controlId="invoice_date" >
                                    <Form.Label>{t('fields.invoiceDate')}</Form.Label>
                                    <Form.Control
                                        as="input"
                                        value={values.invoice_date || ''}
                                        onChange={handleChange}
                                        type="date"
                                    />
                                </Form.Group>
                                <Form.Group controlId="invoice_number" >
                                    <Form.Label>{t('fields.invoiceNumber')}</Form.Label>
                                    <Form.Control
                                        as="input"
                                        value={values.invoice_number || ''}
                                        onChange={handleChange}
                                        type="text"
                                    />
                                </Form.Group>
                            </div>
                        </section>
                    )}
                </TabContent>
            </Tab>
            <Tab eventKey="costs" title={renderTabTitle('costs', t('nav.costs'))}>
            <TabContent>
                <div className="row">                     
                    <div className="col-md-4">
                        <h4 className="form-section-title">{t('fields.materials')}</h4>
                        <div className="row">
                            <div className="col-md-7">
                                <Form.Group>
                                    <Form.Label>{t('fields.searchMaterial')}</Form.Label>
                                    <Form.Control
                                        as="input"
                                        placeholder={t('taskForm.searchMaterial')}
                                        value={materialSearch}
                                        onChange={e => setMaterialSearch(e.target.value)}
                                        className="mb-2"
                                    />
                                    <Form.Control
                                        as="select"
                                        value={selectedMaterialId}
                                        onChange={e => setSelectedMaterialId(e.target.value)}
                                    >
                                        <option value=""></option>
                                        {inventoryItems
                                            .filter(item => {
                                                if (!materialSearch) return true;
                                                const q = materialSearch.toLowerCase();
                                                const itemId = (item.itemId || '').toLowerCase();
                                                const desc = (item.description || '').toLowerCase();
                                                return itemId.includes(q) || desc.includes(q);
                                            })
                                            .slice(0, 200)
                                            .map(item => (
                                            <option key={item.itemId} value={item.itemId}>
                                                {item.itemId} - {item.description} ({Number(item.price || 0).toFixed(2)})
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-md-3">
                                <Form.Group>
                                    <Form.Label>{t('fields.qty')}</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="1"
                                        min="1"
                                        value={selectedMaterialQty}
                                        onChange={e => setSelectedMaterialQty(e.target.value)}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-2 pt-2">
                                <br />
                                <Button
                                    type="button"
                                    size="sm"
                                    variant="primary"
                                    onClick={() => {
                                        const invItem = inventoryItems.find(item => item.itemId === selectedMaterialId);
                                        const qty = parseInt(selectedMaterialQty, 10);
                                        if (!invItem || !qty || qty < 1) return;
                                        const line = {
                                            itemId: invItem.itemId,
                                            description: invItem.description,
                                            quantity: qty,
                                            price: Number(invItem.price || 0),
                                            total: +(parseFloat(Number(invItem.price || 0) * qty)).toFixed(2),
                                        };
                                        const current = values.materials_items || [];
                                        const existingIdx = current.findIndex(i => i.itemId === line.itemId);
                                        let updated = [...current];
                                        if (existingIdx >= 0) {
                                            const nextQty = Number(updated[existingIdx].quantity || 0) + qty;
                                            updated[existingIdx] = {
                                                ...updated[existingIdx],
                                                quantity: nextQty,
                                                total: +(parseFloat(nextQty * Number(updated[existingIdx].price || 0))).toFixed(2),
                                            };
                                        } else {
                                            updated.push(line);
                                        }
                                        const materialsTotal = +(parseFloat(updated.reduce((sum, i) => sum + Number(i.total || 0), 0))).toFixed(2);
                                        setFieldValue('materials_items', updated, false);
                                        setFieldValue('materials', materialsTotal, false);
                                        setFieldValue('total_cost', calculateTotalCost(materialsTotal, values.callout_subtotal, values.onsite_subtotal), false);
                                        setSelectedMaterialQty(1);
                                        setSelectedMaterialId('');
                                    }}
                                >
                                    <FaPlus />
                                </Button>
                            </div>
                            <div className="col-md-12">
                                <Form.Group controlId="materials" >
                                    <Form.Label>{t('fields.materialsTotal')}</Form.Label>
                                    <Form.Control
                                        as="input"
                                        value={values.materials || 0}
                                        readOnly
                                        type="number"
                                        step="0.01"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                {(values.materials_items && values.materials_items.length > 0) ? (
                                    <div className="border rounded p-2">
                                        {values.materials_items.map((item, idx) => (
                                            <div key={item.itemId + '_' + idx} className="d-flex justify-content-between align-items-center border-bottom py-1">
                                                <div>
                                                    <strong>{item.itemId}</strong> - {item.description} x {item.quantity}
                                                </div>
                                                <div>
                                                    {Number(item.total || 0).toFixed(2)}
                                                    <Button
                                                        type="button"
                                                        className="ml-2"
                                                        size="sm"
                                                        variant="outline-danger"
                                                        onClick={() => {
                                                            const updated = (values.materials_items || []).filter((_, i) => i !== idx);
                                                            const materialsTotal = +(parseFloat(updated.reduce((sum, i) => sum + Number(i.total || 0), 0))).toFixed(2);
                                                            setFieldValue('materials_items', updated, false);
                                                            setFieldValue('materials', materialsTotal, false);
                                                            setFieldValue('total_cost', calculateTotalCost(materialsTotal, values.callout_subtotal, values.onsite_subtotal), false);
                                                        }}
                                                    >
                                                        <FaTrash />
                                                    </Button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-muted">{t('taskForm.noMaterials')}</div>
                                )}
                            </div>
                        </div>
                    </div>  
                    <div className="col-md-4">
                        <h4 className="form-section-title">{t('fields.callOutFee')}</h4>
                        {/* Call Out Fee */}
                        <div>
                        <Form.Group controlId="callout_nr" >
                            <Form.Label>{t('fields.nr')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.callout_nr} 
                                onChange={e => { 
                                    handleChange(e); 
                                    // handleCost(e); 

                                    let total_cost = 0;

                                    let callout_subtotal = values.callout_subtotal || 0;
                                    const onsite_subtotal = values.onsite_subtotal || 0;
                                    const materials = values.materials || 0;
            
                                    if (e.target.value >=0 && values.callout_rate >= 0) {
                                        callout_subtotal =  +(parseFloat(e.target.value) * values.callout_rate).toFixed(2);}

                                    if (materials>0 || callout_subtotal>0 || onsite_subtotal>0){
                                    	total_cost = materials + callout_subtotal + onsite_subtotal;
                                    	total_cost = +(parseFloat(total_cost)).toFixed(2)
                                    }
                                    setFieldValue('callout_subtotal', callout_subtotal, false); 
                                    setFieldValue('total_cost', total_cost, false); 
                                }}
                                type="number" 
                                step="0.01" />
                        </Form.Group>   
                        </div>
                        <div>
                        <Form.Group controlId="callout_rate" >
                            <Form.Label>{t('fields.rate')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.callout_rate} 
                                onChange={e => { handleChange(e);
                                
                                    let total_cost = 0;

                                    let callout_subtotal = values.callout_subtotal || 0;
                                    const onsite_subtotal = values.onsite_subtotal || 0;
                                    const materials = values.materials || 0;
            
                                    if (e.target.value >0 && values.callout_nr > 0) {
                                        callout_subtotal =  +(parseFloat(e.target.value) * values.callout_nr).toFixed(2);}

                                    if (materials>0 || callout_subtotal>=0 || onsite_subtotal>=0){
                                    	total_cost = materials + callout_subtotal + onsite_subtotal;
                                    	total_cost = +(parseFloat(total_cost)).toFixed(2)
                                    }
                                    setFieldValue('callout_subtotal', callout_subtotal, false); 
                                    setFieldValue('total_cost', total_cost, false); 
                                
                                }}
                                type="number"
                                step="0.01" />
                        </Form.Group>   
                        </div>
                        <div>
                        <Form.Group controlId="callout_subtotal" >
                            <Form.Label>{t('fields.subtotal')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.callout_subtotal} 
                                onChange={handleChange}
                                type="number" 
                                step="0.01" />
                        </Form.Group>   
                        </div>
                    </div>  
                    <div className="col-md-4">
                        <h4 className="form-section-title">{t('fields.onSiteLabour')}</h4>
                        {/* On Site Labour Cost */}
                        <div>
                        <Form.Group controlId="onsite_nr" >
                            <Form.Label>{t('fields.nr')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.onsite_nr} 
                                onChange={e => { handleChange(e);                              
                               
                                    let total_cost = 0;

                                    const callout_subtotal = values.callout_subtotal || 0;
                                    let onsite_subtotal = values.onsite_subtotal || 0;
                                    const materials = values.materials || 0;
            
                                    if (e.target.value >0 && values.onsite_rate > 0) {
                                        onsite_subtotal =  +(parseFloat(e.target.value) * values.onsite_rate).toFixed(2);}

                                    if (materials>0 || callout_subtotal>=0 || onsite_subtotal>=0){
                                    	total_cost = materials + callout_subtotal + onsite_subtotal;
                                    	total_cost = +(parseFloat(total_cost)).toFixed(2)
                                    }
                                    setFieldValue('onsite_subtotal', onsite_subtotal, false); 
                                    setFieldValue('total_cost', total_cost, false); 
                                }} 
                                type="number" 
                                step="0.01" />
                        </Form.Group>   
                        </div>
                        <div>
                        <Form.Group controlId="onsite_rate" >
                            <Form.Label>{t('fields.rate')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.onsite_rate} 
                                onChange={e => { handleChange(e);
                                    let total_cost = 0;

                                    const callout_subtotal = values.callout_subtotal || 0;
                                    let onsite_subtotal = values.onsite_subtotal || 0;
                                    const materials = values.materials || 0;
            
                                    if (e.target.value >=0 && values.onsite_nr >= 0) {
                                        onsite_subtotal =  +(parseFloat(e.target.value) * values.onsite_nr).toFixed(2);}

                                    if (materials>0 || callout_subtotal>0 || onsite_subtotal>0){
                                    	total_cost = materials + callout_subtotal + onsite_subtotal;
                                    	total_cost = +(parseFloat(total_cost)).toFixed(2)
                                    }
                                    setFieldValue('onsite_subtotal', onsite_subtotal, false); 
                                    setFieldValue('total_cost', total_cost, false); 
                                }}
                                type="number" 
                                step="0.01" />
                        </Form.Group>   
                        </div>
                        <div>
                        <Form.Group controlId="onsite_subtotal" >
                            <Form.Label>{t('fields.subtotal')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.onsite_subtotal} 
                                onChange={handleChange} 
                                type="number" 
                                step="0.01" />
                        </Form.Group>   
                        </div>
                    </div>
                    <div className="col-md-12">
                        <h4 className="form-section-title">{t('fields.totalCost')}</h4>
                        <div className="form-grid">
                        <Form.Group controlId="total_cost" >
                            <Form.Label>{t('fields.totalCost')}</Form.Label>
                            <Form.Control 
                                as="input" 
                                value={values.total_cost} 
                                onChange={handleChange}
                                type="number" 
                                step="0.01" />
                        </Form.Group>
                        </div>
                    </div>
                </div>
            </TabContent>    
            </Tab>
            <Tab eventKey="inspection" title={(() => {
                                const ri = values.ri || task.ri;
                                const hasAlert = ri && Object.values(ri).some(q => q && !q.ok);
                                const hasError = getTabHasError('inspection');
                                if (hasError || hasAlert) {
                                    return <span className='text-danger'>{t('fields.routineInspection')} <FaExclamationCircle /></span>;
                                }
                                return t('fields.routineInspection');
                            })()} disabled={!task.ri && !values.ri}>
                <TabContent>
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="form-section-title">{t('fields.routineInspection')}</h4>
                        </div>
                        <div className="col-md-12">
                            {(() => {
                                const isAdmin = props.user && props.user.administrator === 'true';
                                const ri = values.ri || task.ri || {
                                    q1_lamps: { ok: true, problem: '' },
                                    q2_signal_heads: { ok: true, problem: '' },
                                    q3_caps_bungs: { ok: true, problem: '' },
                                    q4_push_buttons: { ok: true, problem: '' },
                                    q5_controller: { ok: true, problem: '' },
                                    q6_detection: { ok: true, problem: '' },
                                    q7_log_book: { ok: true, problem: '' },
                                    q8_site_issues: { ok: true, problem: '' },
                                    q9_door: { ok: true, problem: '' }
                                };
                                
                                const questions = [
                                    { key: 'q1_lamps', label: t('ri.lampsFault') },
                                    { key: 'q2_signal_heads', label: t('ri.signalHeads') },
                                    { key: 'q3_caps_bungs', label: t('ri.poleCaps') },
                                    { key: 'q4_push_buttons', label: t('ri.pushButtons') },
                                    { key: 'q5_controller', label: t('ri.controllers') },
                                    { key: 'q6_detection', label: t('ri.detection') },
                                    { key: 'q7_log_book', label: t('ri.logBook') },
                                    { key: 'q8_site_issues', label: t('ri.siteIssues') },
                                    { key: 'q9_door', label: t('ri.doorClosed') }
                                ];

                                return (
                                    <>
                                        {questions.map((q) => {
                                            const questionData = ri[q.key] || { ok: true, problem: '' };
                                            const riPath = `ri.${q.key}`;
                                            
                                            return (
                                                <div key={q.key} className="ri-row">
                                                    <div className="col-md-5">
                                                        <Form.Label><strong>{q.label}</strong></Form.Label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <Form.Group>
                                                            <Form.Control
                                                                as="select"
                                                                value={questionData.ok ? 'true' : 'false'}
                                                                onChange={(e) => {
                                                                    if (!isAdmin) return;
                                                                    const isOk = e.target.value === 'true';
                                                                    const newRi = {
                                                                        ...ri,
                                                                        [q.key]: {
                                                                            ...questionData,
                                                                            ok: isOk,
                                                                            // Clear problem text if set to OK
                                                                            problem: isOk ? '' : questionData.problem
                                                                        }
                                                                    };
                                                                    setFieldValue('ri', newRi);
                                                                }}
                                                                disabled={!isAdmin}
                                                            >
                                                                <option value="true">OK</option>
                                                                <option value="false">{t('fields.problem')}</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <Form.Group>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows="2"
                                                                placeholder={t('taskForm.problemDescription')}
                                                                value={questionData.problem || ''}
                                                                onChange={(e) => {
                                                                    if (!isAdmin) return;
                                                                    const newRi = {
                                                                        ...ri,
                                                                        [q.key]: {
                                                                            ...questionData,
                                                                            problem: e.target.value
                                                                        }
                                                                    };
                                                                    setFieldValue('ri', newRi);
                                                                }}
                                                                disabled={!isAdmin || questionData.ok}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>
                                );
                            })()}
                        </div>
                    </div>
                </TabContent>
            </Tab>
            </Tabs>

                              
            </div>    
            </div>                       			
            </form>  
             
            </div>    
                             
        </div>
        
        );
        }}
        </Formik>
        </React.Fragment>
        ) : ''
    );
    
}


const mapStateToProps = state => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps )(TaskAdd);